module.exports = {
	"contractName": "Ethernaut",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "player",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "instance",
					"type": "address"
				}
			],
			"name": "LevelInstanceCreatedLog",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "player",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "level",
					"type": "address"
				}
			],
			"name": "LevelCompletedLog",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_level",
					"type": "address"
				}
			],
			"name": "registerLevel",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_level",
					"type": "address"
				}
			],
			"name": "createLevelInstance",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				}
			],
			"name": "submitLevelInstance",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "121:1852:0:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;121:1852:0;;;;;;",
	"deployedSourceMap": "121:1852:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;391:96;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;391:96:0;-1:-1:-1;;;;;391:96:0;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;;;;;-1:-1:-1;;;;;238:20:29;;;;;;;;;;;;;;1406:565:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;1406:565:0;-1:-1:-1;;;;;1406:565:0;;;;;898:504;;-1:-1:-1;;;;;898:504:0;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;391:96:0;653:5:29;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;451:24:0;;;;;478:4;451:24;;;;;;;;:31;;-1:-1:-1;;451:31:0;;;;;;391:96::o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;1406:565:0:-;-1:-1:-1;;;;;1531:27:0;;;1496:32;1531:27;;;:16;:27;;;;;1572:11;;1531:27;;1572:11;1587:10;1572:25;1564:34;;;;;;1652:14;;;;;;;;;:23;1644:32;;;;;;1754:10;;;;:50;;;;;;-1:-1:-1;;;;;1754:50:0;;;;;;;1793:10;1754:50;;;;;;:10;;;;;:27;;:50;;;;;;;;;;;;;;:10;;:50;;;5:2:-1;;;;30:1;27;20:12;5:2;1754:50:0;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;1754:50:0;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;1754:50:0;1750:217;;;1872:4;1855:14;;:21;;-1:-1:-1;;1855:21:0;;;;;;;1919:41;;;-1:-1:-1;;;;;1949:10:0;;;1919:41;;;1937:10;;1919:41;;;;;;;;;;1750:217;1406:565;;:::o;898:504::-;-1:-1:-1;;;;;1005:24:0;;1085:16;1005:24;;;:16;:24;;;;;;;;997:33;;;;;;;;1104:50;;;;;;1143:10;1104:50;;;;;;-1:-1:-1;;;;;1104:21:0;;;;;1132:9;;1104:50;;;;;;;;;;;;;;;1132:9;1104:21;:50;;;5:2:-1;;;;30:1;27;20:12;5:2;1104:50:0;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;1104:50:0;;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;1104:50:0;1256:46;;;;;;;;1276:10;1256:46;;;-1:-1:-1;;;;;1256:46:0;;;1104:50;1256:46;;;;;;-1:-1:-1;1256:46:0;;;;;;1227:26;;;;;;:16;:26;;;;;;:75;;;;;;;-1:-1:-1;;1227:75:0;;;;;;;;1256:46;1227:75;;;;;;;;;;;;-1:-1:-1;;1227:75:0;;;;;;;;;;;;;;;;;;;1352:45;;;;;;;1104:50;;-1:-1:-1;1276:10:0;1352:45;;;;;;;;;;;898:504;;:::o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o",
	"source": "pragma solidity ^0.4.18;\n\nimport \"./levels/base/Level.sol\";\nimport \"zeppelin-solidity/contracts/ownership/Ownable.sol\";\n\ncontract Ethernaut is Ownable {\n  // ----------------------------------\n  // Owner interaction\n  // ----------------------------------\n\n  mapping(address => bool) registeredLevels;\n\n  // Only registered levels will be allowed to generate and validate level instances.\n  function registerLevel(Level _level) public onlyOwner {\n    registeredLevels[_level] = true;\n  }\n\n  // ----------------------------------\n  // Get/submit level instances\n  // ----------------------------------\n\n  struct EmittedInstanceData {\n    address player;\n    Level level;\n    bool completed;\n  }\n\n  mapping(address => EmittedInstanceData) emittedInstances;\n\n  event LevelInstanceCreatedLog(address indexed player, address instance);\n  event LevelCompletedLog(address indexed player, Level level);\n\n  function createLevelInstance(Level _level) public payable {\n    // Ensure level is registered.\n    require(registeredLevels[_level]);\n\n    // Get level factory to create an instance.\n    address instance = _level.createInstance.value(msg.value)(msg.sender);\n\n    // Store emitted instance relationship with player and level.\n    emittedInstances[instance] = EmittedInstanceData(msg.sender, _level, false);\n\n    // Retrieve created instance via logs.\n    LevelInstanceCreatedLog(msg.sender, instance);\n  }\n\n  function submitLevelInstance(address _instance) public {\n    // Get player and level.\n    EmittedInstanceData storage data = emittedInstances[_instance];\n    require(data.player == msg.sender); // instance was emitted for this player\n    require(data.completed == false); // not already submitted\n\n    // Have the level check the instance.\n    if (data.level.validateInstance(_instance, msg.sender)) {\n      // Register instance as completed.\n      data.completed = true;\n\n      // Notify success via logs.\n      LevelCompletedLog(msg.sender, data.level);\n    }\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/Cypherpunks.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/Cypherpunks.sol",
		"exportedSymbols": {
			"Ethernaut": [
				137
			]
		},
		"id": 138,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:0"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./levels/base/Level.sol",
				"id": 2,
				"nodeType": "ImportDirective",
				"scope": 138,
				"sourceUnit": 2867,
				"src": "26:33:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"file": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"id": 3,
				"nodeType": "ImportDirective",
				"scope": 138,
				"sourceUnit": 2923,
				"src": "60:59:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 4,
							"name": "Ownable",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2922,
							"src": "143:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Ownable_$2922",
								"typeString": "contract Ownable"
							}
						},
						"id": 5,
						"nodeType": "InheritanceSpecifier",
						"src": "143:7:0"
					}
				],
				"contractDependencies": [
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 137,
				"linearizedBaseContracts": [
					137,
					2922
				],
				"name": "Ethernaut",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 9,
						"name": "registeredLevels",
						"nodeType": "VariableDeclaration",
						"scope": 137,
						"src": "259:41:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
							"typeString": "mapping(address => bool)"
						},
						"typeName": {
							"id": 8,
							"keyType": {
								"id": 6,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "267:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "259:24:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
								"typeString": "mapping(address => bool)"
							},
							"valueType": {
								"id": 7,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "278:4:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 22,
							"nodeType": "Block",
							"src": "445:42:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 20,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 16,
												"name": "registeredLevels",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 9,
												"src": "451:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 18,
											"indexExpression": {
												"argumentTypes": null,
												"id": 17,
												"name": "_level",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 11,
												"src": "468:6:0",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Level_$2866",
													"typeString": "contract Level"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "451:24:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 19,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "478:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "451:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 21,
									"nodeType": "ExpressionStatement",
									"src": "451:31:0"
								}
							]
						},
						"documentation": null,
						"id": 23,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 14,
								"modifierName": {
									"argumentTypes": null,
									"id": 13,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2896,
									"src": "435:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "435:9:0"
							}
						],
						"name": "registerLevel",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 12,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 11,
									"name": "_level",
									"nodeType": "VariableDeclaration",
									"scope": 23,
									"src": "414:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_contract$_Level_$2866",
										"typeString": "contract Level"
									},
									"typeName": {
										"contractScope": null,
										"id": 10,
										"name": "Level",
										"nodeType": "UserDefinedTypeName",
										"referencedDeclaration": 2866,
										"src": "414:5:0",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Level_$2866",
											"typeString": "contract Level"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "413:14:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 15,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "445:0:0"
						},
						"scope": 137,
						"src": "391:96:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"canonicalName": "Ethernaut.EmittedInstanceData",
						"id": 30,
						"members": [
							{
								"constant": false,
								"id": 25,
								"name": "player",
								"nodeType": "VariableDeclaration",
								"scope": 30,
								"src": "637:14:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								},
								"typeName": {
									"id": 24,
									"name": "address",
									"nodeType": "ElementaryTypeName",
									"src": "637:7:0",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 27,
								"name": "level",
								"nodeType": "VariableDeclaration",
								"scope": 30,
								"src": "657:11:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_contract$_Level_$2866",
									"typeString": "contract Level"
								},
								"typeName": {
									"contractScope": null,
									"id": 26,
									"name": "Level",
									"nodeType": "UserDefinedTypeName",
									"referencedDeclaration": 2866,
									"src": "657:5:0",
									"typeDescriptions": {
										"typeIdentifier": "t_contract$_Level_$2866",
										"typeString": "contract Level"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 29,
								"name": "completed",
								"nodeType": "VariableDeclaration",
								"scope": 30,
								"src": "674:14:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								},
								"typeName": {
									"id": 28,
									"name": "bool",
									"nodeType": "ElementaryTypeName",
									"src": "674:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									}
								},
								"value": null,
								"visibility": "internal"
							}
						],
						"name": "EmittedInstanceData",
						"nodeType": "StructDefinition",
						"scope": 137,
						"src": "604:89:0",
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 34,
						"name": "emittedInstances",
						"nodeType": "VariableDeclaration",
						"scope": 137,
						"src": "697:56:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_struct$_EmittedInstanceData_$30_storage_$",
							"typeString": "mapping(address => struct Ethernaut.EmittedInstanceData)"
						},
						"typeName": {
							"id": 33,
							"keyType": {
								"id": 31,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "705:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "697:39:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_struct$_EmittedInstanceData_$30_storage_$",
								"typeString": "mapping(address => struct Ethernaut.EmittedInstanceData)"
							},
							"valueType": {
								"contractScope": null,
								"id": 32,
								"name": "EmittedInstanceData",
								"nodeType": "UserDefinedTypeName",
								"referencedDeclaration": 30,
								"src": "716:19:0",
								"typeDescriptions": {
									"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
									"typeString": "struct Ethernaut.EmittedInstanceData"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 40,
						"name": "LevelInstanceCreatedLog",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 39,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 36,
									"indexed": true,
									"name": "player",
									"nodeType": "VariableDeclaration",
									"scope": 40,
									"src": "788:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 35,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "788:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 38,
									"indexed": false,
									"name": "instance",
									"nodeType": "VariableDeclaration",
									"scope": 40,
									"src": "812:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 37,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "812:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "787:42:0"
						},
						"src": "758:72:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 46,
						"name": "LevelCompletedLog",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 45,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 42,
									"indexed": true,
									"name": "player",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "857:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 41,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "857:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 44,
									"indexed": false,
									"name": "level",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "881:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_contract$_Level_$2866",
										"typeString": "contract Level"
									},
									"typeName": {
										"contractScope": null,
										"id": 43,
										"name": "Level",
										"nodeType": "UserDefinedTypeName",
										"referencedDeclaration": 2866,
										"src": "881:5:0",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Level_$2866",
											"typeString": "contract Level"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "856:37:0"
						},
						"src": "833:61:0"
					},
					{
						"body": {
							"id": 86,
							"nodeType": "Block",
							"src": "956:446:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 52,
													"name": "registeredLevels",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 9,
													"src": "1005:16:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
														"typeString": "mapping(address => bool)"
													}
												},
												"id": 54,
												"indexExpression": {
													"argumentTypes": null,
													"id": 53,
													"name": "_level",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 48,
													"src": "1022:6:0",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Level_$2866",
														"typeString": "contract Level"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "1005:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 51,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "997:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 55,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "997:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 56,
									"nodeType": "ExpressionStatement",
									"src": "997:33:0"
								},
								{
									"assignments": [
										58
									],
									"declarations": [
										{
											"constant": false,
											"id": 58,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 87,
											"src": "1085:16:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											},
											"typeName": {
												"id": 57,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "1085:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 68,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 65,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "1143:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 66,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1143:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 62,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "1132:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 63,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1132:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 59,
														"name": "_level",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 48,
														"src": "1104:6:0",
														"typeDescriptions": {
															"typeIdentifier": "t_contract$_Level_$2866",
															"typeString": "contract Level"
														}
													},
													"id": 60,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "createInstance",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 2856,
													"src": "1104:21:0",
													"typeDescriptions": {
														"typeIdentifier": "t_function_external_payable$_t_address_$returns$_t_address_$",
														"typeString": "function (address) payable external returns (address)"
													}
												},
												"id": 61,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1104:27:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_external_payable$_t_address_$returns$_t_address_$value_$",
													"typeString": "function (uint256) returns (function (address) payable external returns (address))"
												}
											},
											"id": 64,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1104:38:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_payable$_t_address_$returns$_t_address_$value",
												"typeString": "function (address) payable external returns (address)"
											}
										},
										"id": 67,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1104:50:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1085:69:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 78,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 69,
												"name": "emittedInstances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 34,
												"src": "1227:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_struct$_EmittedInstanceData_$30_storage_$",
													"typeString": "mapping(address => struct Ethernaut.EmittedInstanceData storage ref)"
												}
											},
											"id": 71,
											"indexExpression": {
												"argumentTypes": null,
												"id": 70,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 58,
												"src": "1244:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1227:26:0",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage",
												"typeString": "struct Ethernaut.EmittedInstanceData storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 73,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "1276:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 74,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1276:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												{
													"argumentTypes": null,
													"id": 75,
													"name": "_level",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 48,
													"src": "1288:6:0",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Level_$2866",
														"typeString": "contract Level"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 76,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1296:5:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													{
														"typeIdentifier": "t_contract$_Level_$2866",
														"typeString": "contract Level"
													},
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												],
												"id": 72,
												"name": "EmittedInstanceData",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 30,
												"src": "1256:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_struct$_EmittedInstanceData_$30_storage_ptr_$",
													"typeString": "type(struct Ethernaut.EmittedInstanceData storage pointer)"
												}
											},
											"id": 77,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "structConstructorCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1256:46:0",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_EmittedInstanceData_$30_memory",
												"typeString": "struct Ethernaut.EmittedInstanceData memory"
											}
										},
										"src": "1227:75:0",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage",
											"typeString": "struct Ethernaut.EmittedInstanceData storage ref"
										}
									},
									"id": 79,
									"nodeType": "ExpressionStatement",
									"src": "1227:75:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 81,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "1376:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 82,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1376:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 83,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 58,
												"src": "1388:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 80,
											"name": "LevelInstanceCreatedLog",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 40,
											"src": "1352:23:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$returns$__$",
												"typeString": "function (address,address)"
											}
										},
										"id": 84,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1352:45:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 85,
									"nodeType": "ExpressionStatement",
									"src": "1352:45:0"
								}
							]
						},
						"documentation": null,
						"id": 87,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createLevelInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 49,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 48,
									"name": "_level",
									"nodeType": "VariableDeclaration",
									"scope": 87,
									"src": "927:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_contract$_Level_$2866",
										"typeString": "contract Level"
									},
									"typeName": {
										"contractScope": null,
										"id": 47,
										"name": "Level",
										"nodeType": "UserDefinedTypeName",
										"referencedDeclaration": 2866,
										"src": "927:5:0",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Level_$2866",
											"typeString": "contract Level"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "926:14:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 50,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "956:0:0"
						},
						"scope": 137,
						"src": "898:504:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 135,
							"nodeType": "Block",
							"src": "1461:510:0",
							"statements": [
								{
									"assignments": [
										93
									],
									"declarations": [
										{
											"constant": false,
											"id": 93,
											"name": "data",
											"nodeType": "VariableDeclaration",
											"scope": 136,
											"src": "1496:32:0",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
												"typeString": "struct Ethernaut.EmittedInstanceData"
											},
											"typeName": {
												"contractScope": null,
												"id": 92,
												"name": "EmittedInstanceData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 30,
												"src": "1496:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
													"typeString": "struct Ethernaut.EmittedInstanceData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 97,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 94,
											"name": "emittedInstances",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 34,
											"src": "1531:16:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_struct$_EmittedInstanceData_$30_storage_$",
												"typeString": "mapping(address => struct Ethernaut.EmittedInstanceData storage ref)"
											}
										},
										"id": 96,
										"indexExpression": {
											"argumentTypes": null,
											"id": 95,
											"name": "_instance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 89,
											"src": "1548:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "1531:27:0",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage",
											"typeString": "struct Ethernaut.EmittedInstanceData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1496:62:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 103,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 99,
														"name": "data",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 93,
														"src": "1572:4:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
															"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
														}
													},
													"id": 100,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "player",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 25,
													"src": "1572:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 101,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "1587:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 102,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1587:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "1572:25:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 98,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1564:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 104,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1564:34:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 105,
									"nodeType": "ExpressionStatement",
									"src": "1564:34:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 110,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 107,
														"name": "data",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 93,
														"src": "1652:4:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
															"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
														}
													},
													"id": 108,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "completed",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 29,
													"src": "1652:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 109,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1670:5:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "1652:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 106,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1644:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 111,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1644:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 112,
									"nodeType": "ExpressionStatement",
									"src": "1644:32:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 116,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 89,
												"src": "1782:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 117,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "1793:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 118,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1793:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 113,
													"name": "data",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 93,
													"src": "1754:4:0",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
														"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
													}
												},
												"id": 114,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "level",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 27,
												"src": "1754:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Level_$2866",
													"typeString": "contract Level"
												}
											},
											"id": 115,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "validateInstance",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2865,
											"src": "1754:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_address_$returns$_t_bool_$",
												"typeString": "function (address,address) external returns (bool)"
											}
										},
										"id": 119,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1754:50:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 134,
									"nodeType": "IfStatement",
									"src": "1750:217:0",
									"trueBody": {
										"id": 133,
										"nodeType": "Block",
										"src": "1806:161:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 124,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 120,
															"name": "data",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 93,
															"src": "1855:4:0",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
																"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
															}
														},
														"id": 122,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "completed",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 29,
														"src": "1855:14:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 123,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "1872:4:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "1855:21:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 125,
												"nodeType": "ExpressionStatement",
												"src": "1855:21:0"
											},
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 127,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "1937:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 128,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "1937:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 129,
																"name": "data",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 93,
																"src": "1949:4:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
																	"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
																}
															},
															"id": 130,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "level",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 27,
															"src": "1949:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_Level_$2866",
																"typeString": "contract Level"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															{
																"typeIdentifier": "t_contract$_Level_$2866",
																"typeString": "contract Level"
															}
														],
														"id": 126,
														"name": "LevelCompletedLog",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 46,
														"src": "1919:17:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_contract$_Level_$2866_$returns$__$",
															"typeString": "function (address,contract Level)"
														}
													},
													"id": 131,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1919:41:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 132,
												"nodeType": "ExpressionStatement",
												"src": "1919:41:0"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 136,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "submitLevelInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 90,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 89,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 136,
									"src": "1435:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 88,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1435:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1434:19:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 91,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1461:0:0"
						},
						"scope": 137,
						"src": "1406:565:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 138,
				"src": "121:1852:0"
			}
		],
		"src": "0:1974:0"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/Cypherpunks.sol",
		"exportedSymbols": {
			"Ethernaut": [
				137
			]
		},
		"id": 138,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:0"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./levels/base/Level.sol",
				"id": 2,
				"nodeType": "ImportDirective",
				"scope": 138,
				"sourceUnit": 2867,
				"src": "26:33:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"file": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"id": 3,
				"nodeType": "ImportDirective",
				"scope": 138,
				"sourceUnit": 2923,
				"src": "60:59:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 4,
							"name": "Ownable",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2922,
							"src": "143:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Ownable_$2922",
								"typeString": "contract Ownable"
							}
						},
						"id": 5,
						"nodeType": "InheritanceSpecifier",
						"src": "143:7:0"
					}
				],
				"contractDependencies": [
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 137,
				"linearizedBaseContracts": [
					137,
					2922
				],
				"name": "Ethernaut",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 9,
						"name": "registeredLevels",
						"nodeType": "VariableDeclaration",
						"scope": 137,
						"src": "259:41:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
							"typeString": "mapping(address => bool)"
						},
						"typeName": {
							"id": 8,
							"keyType": {
								"id": 6,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "267:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "259:24:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
								"typeString": "mapping(address => bool)"
							},
							"valueType": {
								"id": 7,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "278:4:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 22,
							"nodeType": "Block",
							"src": "445:42:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 20,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 16,
												"name": "registeredLevels",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 9,
												"src": "451:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 18,
											"indexExpression": {
												"argumentTypes": null,
												"id": 17,
												"name": "_level",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 11,
												"src": "468:6:0",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Level_$2866",
													"typeString": "contract Level"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "451:24:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 19,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "478:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "451:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 21,
									"nodeType": "ExpressionStatement",
									"src": "451:31:0"
								}
							]
						},
						"documentation": null,
						"id": 23,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 14,
								"modifierName": {
									"argumentTypes": null,
									"id": 13,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2896,
									"src": "435:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "435:9:0"
							}
						],
						"name": "registerLevel",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 12,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 11,
									"name": "_level",
									"nodeType": "VariableDeclaration",
									"scope": 23,
									"src": "414:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_contract$_Level_$2866",
										"typeString": "contract Level"
									},
									"typeName": {
										"contractScope": null,
										"id": 10,
										"name": "Level",
										"nodeType": "UserDefinedTypeName",
										"referencedDeclaration": 2866,
										"src": "414:5:0",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Level_$2866",
											"typeString": "contract Level"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "413:14:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 15,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "445:0:0"
						},
						"scope": 137,
						"src": "391:96:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"canonicalName": "Ethernaut.EmittedInstanceData",
						"id": 30,
						"members": [
							{
								"constant": false,
								"id": 25,
								"name": "player",
								"nodeType": "VariableDeclaration",
								"scope": 30,
								"src": "637:14:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								},
								"typeName": {
									"id": 24,
									"name": "address",
									"nodeType": "ElementaryTypeName",
									"src": "637:7:0",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 27,
								"name": "level",
								"nodeType": "VariableDeclaration",
								"scope": 30,
								"src": "657:11:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_contract$_Level_$2866",
									"typeString": "contract Level"
								},
								"typeName": {
									"contractScope": null,
									"id": 26,
									"name": "Level",
									"nodeType": "UserDefinedTypeName",
									"referencedDeclaration": 2866,
									"src": "657:5:0",
									"typeDescriptions": {
										"typeIdentifier": "t_contract$_Level_$2866",
										"typeString": "contract Level"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 29,
								"name": "completed",
								"nodeType": "VariableDeclaration",
								"scope": 30,
								"src": "674:14:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								},
								"typeName": {
									"id": 28,
									"name": "bool",
									"nodeType": "ElementaryTypeName",
									"src": "674:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									}
								},
								"value": null,
								"visibility": "internal"
							}
						],
						"name": "EmittedInstanceData",
						"nodeType": "StructDefinition",
						"scope": 137,
						"src": "604:89:0",
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 34,
						"name": "emittedInstances",
						"nodeType": "VariableDeclaration",
						"scope": 137,
						"src": "697:56:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_struct$_EmittedInstanceData_$30_storage_$",
							"typeString": "mapping(address => struct Ethernaut.EmittedInstanceData)"
						},
						"typeName": {
							"id": 33,
							"keyType": {
								"id": 31,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "705:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "697:39:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_struct$_EmittedInstanceData_$30_storage_$",
								"typeString": "mapping(address => struct Ethernaut.EmittedInstanceData)"
							},
							"valueType": {
								"contractScope": null,
								"id": 32,
								"name": "EmittedInstanceData",
								"nodeType": "UserDefinedTypeName",
								"referencedDeclaration": 30,
								"src": "716:19:0",
								"typeDescriptions": {
									"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
									"typeString": "struct Ethernaut.EmittedInstanceData"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 40,
						"name": "LevelInstanceCreatedLog",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 39,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 36,
									"indexed": true,
									"name": "player",
									"nodeType": "VariableDeclaration",
									"scope": 40,
									"src": "788:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 35,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "788:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 38,
									"indexed": false,
									"name": "instance",
									"nodeType": "VariableDeclaration",
									"scope": 40,
									"src": "812:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 37,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "812:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "787:42:0"
						},
						"src": "758:72:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 46,
						"name": "LevelCompletedLog",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 45,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 42,
									"indexed": true,
									"name": "player",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "857:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 41,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "857:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 44,
									"indexed": false,
									"name": "level",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "881:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_contract$_Level_$2866",
										"typeString": "contract Level"
									},
									"typeName": {
										"contractScope": null,
										"id": 43,
										"name": "Level",
										"nodeType": "UserDefinedTypeName",
										"referencedDeclaration": 2866,
										"src": "881:5:0",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Level_$2866",
											"typeString": "contract Level"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "856:37:0"
						},
						"src": "833:61:0"
					},
					{
						"body": {
							"id": 86,
							"nodeType": "Block",
							"src": "956:446:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 52,
													"name": "registeredLevels",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 9,
													"src": "1005:16:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
														"typeString": "mapping(address => bool)"
													}
												},
												"id": 54,
												"indexExpression": {
													"argumentTypes": null,
													"id": 53,
													"name": "_level",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 48,
													"src": "1022:6:0",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Level_$2866",
														"typeString": "contract Level"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "1005:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 51,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "997:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 55,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "997:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 56,
									"nodeType": "ExpressionStatement",
									"src": "997:33:0"
								},
								{
									"assignments": [
										58
									],
									"declarations": [
										{
											"constant": false,
											"id": 58,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 87,
											"src": "1085:16:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											},
											"typeName": {
												"id": 57,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "1085:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 68,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 65,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "1143:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 66,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1143:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 62,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "1132:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 63,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1132:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 59,
														"name": "_level",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 48,
														"src": "1104:6:0",
														"typeDescriptions": {
															"typeIdentifier": "t_contract$_Level_$2866",
															"typeString": "contract Level"
														}
													},
													"id": 60,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "createInstance",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 2856,
													"src": "1104:21:0",
													"typeDescriptions": {
														"typeIdentifier": "t_function_external_payable$_t_address_$returns$_t_address_$",
														"typeString": "function (address) payable external returns (address)"
													}
												},
												"id": 61,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1104:27:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_external_payable$_t_address_$returns$_t_address_$value_$",
													"typeString": "function (uint256) returns (function (address) payable external returns (address))"
												}
											},
											"id": 64,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1104:38:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_payable$_t_address_$returns$_t_address_$value",
												"typeString": "function (address) payable external returns (address)"
											}
										},
										"id": 67,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1104:50:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1085:69:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 78,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 69,
												"name": "emittedInstances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 34,
												"src": "1227:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_struct$_EmittedInstanceData_$30_storage_$",
													"typeString": "mapping(address => struct Ethernaut.EmittedInstanceData storage ref)"
												}
											},
											"id": 71,
											"indexExpression": {
												"argumentTypes": null,
												"id": 70,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 58,
												"src": "1244:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1227:26:0",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage",
												"typeString": "struct Ethernaut.EmittedInstanceData storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 73,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "1276:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 74,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1276:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												{
													"argumentTypes": null,
													"id": 75,
													"name": "_level",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 48,
													"src": "1288:6:0",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Level_$2866",
														"typeString": "contract Level"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 76,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1296:5:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													{
														"typeIdentifier": "t_contract$_Level_$2866",
														"typeString": "contract Level"
													},
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												],
												"id": 72,
												"name": "EmittedInstanceData",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 30,
												"src": "1256:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_struct$_EmittedInstanceData_$30_storage_ptr_$",
													"typeString": "type(struct Ethernaut.EmittedInstanceData storage pointer)"
												}
											},
											"id": 77,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "structConstructorCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1256:46:0",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_EmittedInstanceData_$30_memory",
												"typeString": "struct Ethernaut.EmittedInstanceData memory"
											}
										},
										"src": "1227:75:0",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage",
											"typeString": "struct Ethernaut.EmittedInstanceData storage ref"
										}
									},
									"id": 79,
									"nodeType": "ExpressionStatement",
									"src": "1227:75:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 81,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "1376:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 82,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1376:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 83,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 58,
												"src": "1388:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 80,
											"name": "LevelInstanceCreatedLog",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 40,
											"src": "1352:23:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$returns$__$",
												"typeString": "function (address,address)"
											}
										},
										"id": 84,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1352:45:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 85,
									"nodeType": "ExpressionStatement",
									"src": "1352:45:0"
								}
							]
						},
						"documentation": null,
						"id": 87,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createLevelInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 49,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 48,
									"name": "_level",
									"nodeType": "VariableDeclaration",
									"scope": 87,
									"src": "927:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_contract$_Level_$2866",
										"typeString": "contract Level"
									},
									"typeName": {
										"contractScope": null,
										"id": 47,
										"name": "Level",
										"nodeType": "UserDefinedTypeName",
										"referencedDeclaration": 2866,
										"src": "927:5:0",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Level_$2866",
											"typeString": "contract Level"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "926:14:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 50,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "956:0:0"
						},
						"scope": 137,
						"src": "898:504:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 135,
							"nodeType": "Block",
							"src": "1461:510:0",
							"statements": [
								{
									"assignments": [
										93
									],
									"declarations": [
										{
											"constant": false,
											"id": 93,
											"name": "data",
											"nodeType": "VariableDeclaration",
											"scope": 136,
											"src": "1496:32:0",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
												"typeString": "struct Ethernaut.EmittedInstanceData"
											},
											"typeName": {
												"contractScope": null,
												"id": 92,
												"name": "EmittedInstanceData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 30,
												"src": "1496:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
													"typeString": "struct Ethernaut.EmittedInstanceData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 97,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 94,
											"name": "emittedInstances",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 34,
											"src": "1531:16:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_struct$_EmittedInstanceData_$30_storage_$",
												"typeString": "mapping(address => struct Ethernaut.EmittedInstanceData storage ref)"
											}
										},
										"id": 96,
										"indexExpression": {
											"argumentTypes": null,
											"id": 95,
											"name": "_instance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 89,
											"src": "1548:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "1531:27:0",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage",
											"typeString": "struct Ethernaut.EmittedInstanceData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1496:62:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 103,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 99,
														"name": "data",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 93,
														"src": "1572:4:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
															"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
														}
													},
													"id": 100,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "player",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 25,
													"src": "1572:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 101,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "1587:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 102,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1587:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "1572:25:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 98,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1564:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 104,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1564:34:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 105,
									"nodeType": "ExpressionStatement",
									"src": "1564:34:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 110,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 107,
														"name": "data",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 93,
														"src": "1652:4:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
															"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
														}
													},
													"id": 108,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "completed",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 29,
													"src": "1652:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 109,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1670:5:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "1652:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 106,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1644:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 111,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1644:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 112,
									"nodeType": "ExpressionStatement",
									"src": "1644:32:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 116,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 89,
												"src": "1782:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 117,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "1793:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 118,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1793:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 113,
													"name": "data",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 93,
													"src": "1754:4:0",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
														"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
													}
												},
												"id": 114,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "level",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 27,
												"src": "1754:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Level_$2866",
													"typeString": "contract Level"
												}
											},
											"id": 115,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "validateInstance",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2865,
											"src": "1754:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_address_$returns$_t_bool_$",
												"typeString": "function (address,address) external returns (bool)"
											}
										},
										"id": 119,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1754:50:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 134,
									"nodeType": "IfStatement",
									"src": "1750:217:0",
									"trueBody": {
										"id": 133,
										"nodeType": "Block",
										"src": "1806:161:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 124,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 120,
															"name": "data",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 93,
															"src": "1855:4:0",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
																"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
															}
														},
														"id": 122,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "completed",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 29,
														"src": "1855:14:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 123,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "1872:4:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "1855:21:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 125,
												"nodeType": "ExpressionStatement",
												"src": "1855:21:0"
											},
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 127,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "1937:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 128,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "1937:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 129,
																"name": "data",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 93,
																"src": "1949:4:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_EmittedInstanceData_$30_storage_ptr",
																	"typeString": "struct Ethernaut.EmittedInstanceData storage pointer"
																}
															},
															"id": 130,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "level",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 27,
															"src": "1949:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_Level_$2866",
																"typeString": "contract Level"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															{
																"typeIdentifier": "t_contract$_Level_$2866",
																"typeString": "contract Level"
															}
														],
														"id": 126,
														"name": "LevelCompletedLog",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 46,
														"src": "1919:17:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_contract$_Level_$2866_$returns$__$",
															"typeString": "function (address,contract Level)"
														}
													},
													"id": 131,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1919:41:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 132,
												"nodeType": "ExpressionStatement",
												"src": "1919:41:0"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 136,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "submitLevelInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 90,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 89,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 136,
									"src": "1435:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 88,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1435:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1434:19:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 91,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1461:0:0"
						},
						"scope": 137,
						"src": "1406:565:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 138,
				"src": "121:1852:0"
			}
		],
		"src": "0:1974:0"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.793Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Ethernaut.json
// module id = 307
// module chunks = 0